
import data from "../data/data";
import Project from "../components/projects/Project";

const Projects = () => {
    return (
        <section className="app__projects -page">
            <div className="app__projects-container app__container">
                <div className="app__projects-header">
                    <h2> Projects & Portfolio </h2>
                </div>
                <div className="app__projects-body">
                    <div className="app__projects-row -grid gap-2">
                        { data.projects.map(project => (
                            <Project 
                                key={project.id}
                                data={project}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Projects;